import type { PainTrendConfig, WidgetConfig } from "@/lib/schema";
import { getWidgetModule } from "@/widgets/registry";
import type { WeekWidgetModule } from "@/widgets/types";
import { SettingsEditor } from "./SettingsEditor";
import { validate } from "./validate";
import { WeekView } from "./WeekView";

function defaults(existing: WidgetConfig[]): PainTrendConfig {
  const weekWidgets = existing.filter(
    (w) => getWidgetModule(w.kind)?.scope === "week",
  );
  const maxRow = weekWidgets.reduce((m, w) => Math.max(m, w.row), -1);
  return {
    id: crypto.randomUUID(),
    kind: "pain-trend",
    label: "Smertetrend",
    row: maxRow + 1,
    column: 0,
    enabled: true,
  };
}

export const painTrend: WeekWidgetModule<PainTrendConfig> = {
  kind: "pain-trend",
  label: "Smertetrend",
  scope: "week",
  scoring: "none",
  defaults,
  validate,
  SettingsEditor,
  WeekView,
};
